export default [
	{
		type: 'enemy',
		slug: 'tongue',
		levels: [
			{ life: 2, attack: 1, armor: 0 },
			{ life: 2, attack: 1, armor: 0 },
			{ life: 3, attack: 1, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "Chaque coup non bloqué inflige (poison 1)[status-poison:1]."
		},
		en: {
			name: "Enemy",
			description: "Each unblocked hit inflicts (poison 1)[status-poison:1]."
		},
		passives: [],
		triggers: [
			{
				on: 'after-deal-damage',
				method: 'deal_poison_to_opponent',
				value: 1
			}
		]
	},
	{
		type: 'enemy',
		slug: 'tentacle',
		levels: [
			{ life: 2, attack: 2, armor: 0 },
			{ life: 3, attack: 2, armor: 0 },
			{ life: 4, attack: 1, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "Après chaque coup, gagne +1 d'attaque."
		},
		en: {
			name: "Enemy",
			description: "After each hit, gains +1 attack."
		},
		passives: [],
		triggers: [
			{
				on: 'after-attack',
				method: 'gain_attack',
				value: 1
			}
		]
	},
	{
		type: 'enemy',
		slug: 'gargoyle',
		levels: [
			{ life: 2, attack: 1, armor: 0 },
			{ life: 3, attack: 1, armor: 0 },
			{ life: 4, attack: 1, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "A la mort, vous donne une carte potion de faiblesse."
		},
		en: {
			name: "Enemy",
			description: "At death, gives you a weakness potion card."
		},
		passives: [],
		triggers: [
			{
				on: 'death',
				method: 'give_card',
				card: 'weakness-potion'
			}
		]
	},
	{
		type: 'enemy',
		slug: 'leaf',
		levels: [
			{ life: 2, attack: 1, armor: 0 },
			{ life: 3, attack: 1, armor: 0 },
			{ life: 4, attack: 1, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "Attaque en premier."
		},
		en: {
			name: "Enemy",
			description: "Attack first."
		},
		passives: [ 'attack-first' ],
		triggers: []
	},
	{
		type: 'enemy',
		slug: 'eyes',
		levels: [
			{ life: 2, attack: 1, armor: 0 },
			{ life: 3, attack: 1, armor: 0 },
			{ life: 4, attack: 1, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "A la mort, confère +1 d'attaque aux ennemis en jeu."
		},
		en: {
			name: "Enemy",
			description: "Upon death, confers +1 attack to enemies in play."
		},
		passives: [],
		triggers: [
			{
				on: 'death',
				method: 'give_attack_to_other_enemies',
				value: 1
			}
		]
	},
	{
		type: 'enemy',
		slug: 'fire',
		boss: true,
		levels: [
			{ life: 6, attack: 2, armor: 0 },
			{ life: 5, attack: 3, armor: 0 },
			{ life: 5, attack: 4, armor: 0 },
		],
		fr: {
			name: "Ennemi",
			description: "Flammes ! Flammes ! Flammes !"
		},
		en: {
			name: "Enemy",
			description: "Flames ! Flames ! Flames !"
		},
		passives: [],
		triggers: [
			{
				on: 'death',
				method: 'give_attack_to_other_enemies',
				value: 1
			}
		]
	},
	{
		type: 'enemy',
		slug: 'pigeon',
		boss: true,
		levels: [
			{ life: 6, attack: 2, armor: 0 },
			{ life: 5, attack: 3, armor: 0 },
			{ life: 5, attack: 4, armor: 0 },
		],
		fr: {
			name: "Boss",
			description: "Un redoutable boss !"
		},
		en: {
			name: "Boss",
			description: "A formidable boss!"
		},
		passives: [],
		triggers: []
	},
	{
		type: 'enemy',
		slug: 'vampire',
		boss: true,
		levels: [
			{ life: 6, attack: 2, armor: 0 },
			{ life: 5, attack: 3, armor: 0 },
			{ life: 5, attack: 4, armor: 0 },
		],
		fr: {
			name: "Boss",
			description: "Un redoutable boss !"
		},
		en: {
			name: "Boss",
			description: "A formidable boss!"
		},
		passives: [],
		triggers: []
	},
	{
		type: 'enemy',
		slug: 'dragon',
		boss: true,
		levels: [
			{ life: 6, attack: 2, armor: 0 },
			{ life: 5, attack: 3, armor: 0 },
			{ life: 5, attack: 4, armor: 0 },
		],
		fr: {
			name: "Boss",
			description: "Un redoutable boss !"
		},
		en: {
			name: "Boss",
			description: "A formidable boss!"
		},
		passives: [],
		triggers: []
	},
	{
		type: 'enemy',
		slug: 'king',
		boss: true,
		levels: [
			{ life: 6, attack: 2, armor: 0 },
			{ life: 5, attack: 3, armor: 0 },
			{ life: 5, attack: 4, armor: 0 },
		],
		fr: {
			name: "Boss",
			description: "Un redoutable boss !"
		},
		en: {
			name: "Boss",
			description: "A formidable boss!"
		},
		passives: [],
		triggers: []
	},
]